isStrict